import {
  createServiceClient,
  tryCreateBrowserClient
} from "./chunk-IPSWFQ5E.mjs";

// src/auth/index.ts
function sanitizeNextPath(nextPath) {
  const FALLBACK = "/square/command-center";
  if (!nextPath) return FALLBACK;
  if (!nextPath.startsWith("/")) return FALLBACK;
  if (nextPath.startsWith("//")) return FALLBACK;
  if (nextPath.includes("\\")) return FALLBACK;
  if (/[\x00-\x1f\x7f]/.test(nextPath)) return FALLBACK;
  let decoded;
  try {
    decoded = decodeURIComponent(nextPath);
  } catch {
    return FALLBACK;
  }
  if (decoded.startsWith("//") || decoded.includes("\\") || /[\x00-\x1f\x7f]/.test(decoded)) {
    return FALLBACK;
  }
  return nextPath;
}
var _browser = null;
var _tried = false;
function browser() {
  if (_tried) return _browser;
  _tried = true;
  _browser = tryCreateBrowserClient();
  return _browser;
}
function resetBrowserAuthClient() {
  _browser = null;
  _tried = false;
}
async function signIn(email, password) {
  const supabase = browser();
  if (!supabase) {
    return { ok: false, user: null, error: "Supabase not configured. Running in demo mode." };
  }
  const { data, error } = await supabase.auth.signInWithPassword({ email, password });
  if (error) return { ok: false, user: null, error: error.message };
  if (!data.user) return { ok: false, user: null, error: "No user returned" };
  return {
    ok: true,
    user: {
      id: data.user.id,
      email: data.user.email ?? null,
      created_at: data.user.created_at ?? null
    },
    error: null
  };
}
async function signOut() {
  const supabase = browser();
  if (!supabase) return { ok: true, error: null };
  const { error } = await supabase.auth.signOut();
  return { ok: !error, error: error?.message ?? null };
}
async function signInWithGitHub(nextPath) {
  const supabase = browser();
  if (!supabase) return { ok: false, error: "Supabase client not available" };
  const safeNext = sanitizeNextPath(nextPath);
  const { error } = await supabase.auth.signInWithOAuth({
    provider: "github",
    options: {
      redirectTo: `${window.location.origin}/auth/callback?next=${encodeURIComponent(safeNext)}`
    }
  });
  return { ok: !error, error: error?.message ?? null };
}
async function getCurrentUser() {
  const supabase = browser();
  if (!supabase) return null;
  try {
    const { data } = await supabase.auth.getUser();
    if (!data.user) return null;
    return {
      id: data.user.id,
      email: data.user.email ?? null,
      created_at: data.user.created_at ?? null
    };
  } catch {
    return null;
  }
}
function onAuthChange(handler) {
  const supabase = browser();
  if (!supabase) return () => {
  };
  try {
    const { data } = supabase.auth.onAuthStateChange((_event, session) => {
      if (!session?.user) {
        handler(null);
      } else {
        handler({
          id: session.user.id,
          email: session.user.email ?? null,
          created_at: session.user.created_at ?? null
        });
      }
    });
    return () => data.subscription.unsubscribe();
  } catch {
    return () => {
    };
  }
}
async function verifyAccessToken(token) {
  if (!token) return null;
  const service = createServiceClient();
  const { data, error } = await service.auth.getUser(token);
  if (error || !data.user) return null;
  return {
    id: data.user.id,
    email: data.user.email ?? null,
    created_at: data.user.created_at ?? null
  };
}

export {
  resetBrowserAuthClient,
  signIn,
  signOut,
  signInWithGitHub,
  getCurrentUser,
  onAuthChange,
  verifyAccessToken
};
